
import { gsap } from 'gsap'
import { SplitText } from 'gsap/SplitText'
import serviceQuery from '~/apollo/queries/service'
if (process.client) {
  gsap.registerPlugin(SplitText)
}
export default {
  layout: 'studioPages',
  async asyncData ({ $graphql, params }) {
    const variables = { slug: params.slug }
    const data = await $graphql.default.request(serviceQuery, variables)
    const jsonld = { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: [] }
    if (data.page.dettagli_servizio?.pilloleTecniche) {
      for (const pil of data.page.dettagli_servizio.pilloleTecniche) {
        jsonld.mainEntity.push({ '@type': 'Question', name: pil.titolo, acceptedAnswer: { '@type': 'Answer', text: pil.testo } })
      }
    }
    return {
      data: data.page,
      jsonld
    }
  },
  data () {
    return {
      showSocial: false,
      page: {},
      loading: 0,
      splitted: [],
      marqueeText: null
    }
  },
  head () {
    return {
      title: this.metaTitle,
      script: [
        ...(this.jsonld.mainEntity.length > 0
          ? [{
              type: 'application/ld+json',
              innerHTML: JSON.stringify(this.jsonld)
            }]
          : [])
      ],
      __dangerouslyDisableSanitizers: ['script'],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaDesc
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://studio375.it/media/logo-studio375.png'
        },
        {
          hid: 'og:image:width',
          property: 'og:image:width',
          content: '1200'
        },
        {
          hid: 'og:image:height',
          property: 'og:image:height',
          content: '630'
        },
        {
          hid: 'og:image:type',
          property: 'og:image:type',
          content: 'image/png'
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.metaTitle
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: 'https://studio375.it' + this.path
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.metaDesc
        },
        {
          hid: 'og:locale',
          property: 'og:locale',
          content: 'it_IT'
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'Studio375'
        }
      ],
      bodyAttrs: {
        class: 'single-post'
      }
    }
  },
  computed: {
    slug () {
      return this.$route.params.slug
    },
    path () {
      if (this.$route.path.charAt(this.$route.path.length - 1) === '/') {
        return this.$route.path
      } else {
        return this.$route.path + '/'
      }
    },
    h1 () {
      return (this.data.dettagli_servizio) ? this.data.dettagli_servizio.h1 : ''
    },
    title () {
      return (this.data.title) ? this.data.title : ''
    },
    sub () {
      return (this.data.dettagli_servizio !== undefined) ? this.data.dettagli_servizio.sub : null
    },
    lateralDesc () {
      return (this.data.dettagli_servizio !== undefined) ? this.data.dettagli_servizio.lateral : null
    },
    img () {
      let url = (this.data.featuredImage !== undefined) ? this.data.featuredImage.node.sourceUrl : ''
      if (url) {
        const split = url.split('https://dna.studio375.it/wp-content')
        url = split[1]
      }
      return url
    },
    content () {
      return (this.data.dettagli_servizio !== undefined) ? this.data.dettagli_servizio.contenuto : null
    },
    faqs () {
      return (this.data.dettagli_servizio && this.data.dettagli_servizio.pilloleTecniche) ? this.data.dettagli_servizio.pilloleTecniche : null
    },
    metaDesc () {
      return this.$store.getters.getSeoBySlug(this.slug).metaDesc
    },
    metaTitle () {
      return this.$store.getters.getSeoBySlug(this.slug).title
    },
    nextPost () {
      const all = this.$store.state.categories
      const services = []
      let next = false
      all.forEach((s, i) => {
        if (s.slug !== 'senza-categoria') {
          services.push(s.slug)
        }
      })

      services.forEach((s, i) => {
        if (s === this.slug) {
          if (i !== (services.length - 1)) {
            next = '/servizi/' + services[i + 1] + '/'
          } else {
            next = '/servizi/' + services[0] + '/'
          }
        }
      })

      return next
    }
    // marqueeText () {
    //   return (this.data.dettagli_servizio !== undefined) ? this.data.dettagli_servizio.marquee : ''
    // }
  },
  mounted () {
    this.marqueeText = this.data.dettagli_servizio.marquee
  },
  methods: {
  }
}
